export function useEnv() {
  return {
    stack: "default",
    defaultStack: "default",
  };
}
